import React from 'react';
import { ContentOption } from '../../Types/Types.ts';

type VerticalOptionProps = {
  option: ContentOption;
  selected: boolean;
  onClick: () => void;
};

const VerticalOption = ({ option, selected, onClick }: VerticalOptionProps) => {
  return (
    <div className={`vertical-option mb-4 px-4 py-4 ${selected ? 'selected' : ''}`} onClick={onClick}>
      <div className="image-wrapper d-flex justify-content-center w-100 mb-3">
        {option.ImageUrl && <img src={option.ImageUrl} alt={option.ImageAlt} />}
      </div>
      <h5 className="mb-2">{option.Title}</h5>
      <p className="paragraph--s">{option.Description}</p>
    </div>
  );
};

export default VerticalOption;
